import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { GET_PLC_SAFETY_CAUSES } from './actionTypes';
import { getPlcSafetyCausesSuccess, getPlcSafetyCausesError } from './actions';
import { getPlcSafetyAPI } from '../../../api/plcSafety';

const plcSafetyAPI = getPlcSafetyAPI();

function* getCauses({ payload: { user, size, page, status } }) {
  try {
    const response = yield call(plcSafetyAPI.getCauses, user.token, size, page, status);
    yield put(getPlcSafetyCausesSuccess(response.paginator, response.message));
  } catch (error) {
    yield put(getPlcSafetyCausesError(error));
  }
}

export function* watchGetPlcSafetyCauses() {
  yield takeEvery(GET_PLC_SAFETY_CAUSES, getCauses);
}

function* getPlcSafetyCausesSaga() {
  yield all([fork(watchGetPlcSafetyCauses)]);
}

export default getPlcSafetyCausesSaga;
